<template>
    <v-expansion-panels
        v-model="panel"
        class="expansion-panel"
    >
        <v-expansion-panel>
            <v-expansion-panel-header class="card-title-2 mt-1">
                <div class="filters-panel">
                    <div class="filter-buttons">
                        <v-icon v-if="assignmentViewPreference === 'array'" :color="theming.cardsAndTablesText || 'black'" class="px-2" @click.stop="changeView()" large>
                            mdi-view-day
                        </v-icon>
                        <v-icon v-else :color="theming.cardsAndTablesText || 'black'" class="pr-2" @click.stop="changeView()" large>
                            mdi-table
                        </v-icon>
                        Αναθέσεις
                        <v-icon :color="theming.cardsAndTablesText || 'black'" class="px-4" @click.stop="togglePanel()" large>
                            mdi-tune
                        </v-icon>
                        <v-icon :color="theming.cardsAndTablesText || 'black'" @click.stop="toggleClearButton()" large>
                            mdi-sort-variant-remove
                        </v-icon>
                    </div>
                    <div @click.stop="" class="sort-wrapper">
                        <div v-if="this.sortBy" @click.stop="toggleSortType">
                            <v-icon v-if="sortType === 'ASC'" :color="theming.cardsAndTablesText || 'black'">mdi-sort-alphabetical-ascending</v-icon>
                            <v-icon v-else :color="theming.cardsAndTablesText || 'black'">mdi-sort-alphabetical-descending</v-icon>
                        </div>
                        <v-select
                            v-model="sortBy"
                            :items="sortSelections"
                            item-text="text"
                            item-value="value"
                            label="Sort by"
                            class="sort-by-selection"
                            @change="onSearch"
                            clearable
                        ></v-select>
                    </div>
                    <div v-if="containsAny(['ROLE_ADMIN', 'ROLE_COORDINATOR'], userRoles)" class="create-new">
                        <v-btn class="my-2 mr-2" dark small color="black" @click="createAssignment">
                            <v-icon dark>mdi-plus</v-icon>ΔΗΜΙΟΥΡΓΙΑ ΝΕΑΣ
                        </v-btn>
                    </div>
                </div>
            </v-expansion-panel-header>
            <v-divider/>
            <v-expansion-panel-content>
                <v-tabs
                    v-model="selectedTab"
                    fixed-tabs
                    dark
                >
                    <v-tabs-slider color="#FFC000"></v-tabs-slider>
                    <v-tab v-for="tab in this.tabs" :key="tab.value" :disabled="shouldTabBeDisabled(tab)" @click="selectTab">
                        {{ tab.text }}
                    </v-tab>
                </v-tabs>
                <div v-if="this.tabs[selectedTab].value === 'freeSearch'">
                    <div class="like-search-wrapper">
                        <v-text-field
                            v-model="filter.sr"
                            label="SR"
                            type="text"
                            class="filter-field sr"
                            clearable
                            @input="likeFieldTriggered"
                        >
                            <template v-slot:prepend-inner>
                                <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-text-search-variant</v-icon>
                            </template>
                        </v-text-field>
                        <v-text-field
                            v-model="filter.clientName"
                            label="Ονοματεπώνυμο Πελάτη"
                            type="text"
                            class="filter-field client-name"
                            :disabled="!!this.filter.sr"
                            clearable
                            @input="likeFieldTriggered"
                        >
                            <template v-slot:prepend-inner>
                                <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-account</v-icon>
                            </template>
                        </v-text-field>
                    </div>
                    <div class="like-search-wrapper">
                        <v-text-field
                            v-model="filter.buildingId"
                            label="Building ID"
                            type="text"
                            class="filter-field building-id"
                            clearable
                            :disabled="!!this.filter.sr"
                            @input="likeFieldTriggered"
                        >
                            <template v-slot:prepend-inner>
                                <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-domain</v-icon>
                            </template>
                        </v-text-field>
                        <v-text-field
                            v-model="filter.address"
                            label="Διεύθυνση"
                            type="text"
                            class="filter-field address"
                            clearable
                            :disabled="!!this.filter.sr"
                            @input="likeFieldTriggered"
                        >
                            <template v-slot:prepend-inner>
                                <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-map-marker</v-icon>
                            </template>
                        </v-text-field>
                    </div>
                    <div class="search-button-wrapper">
                        <v-btn v-if="containsAny(['ROLE_ADMIN', 'ROLE_COORDINATOR'], userRoles)" class="mx-2 white--text" medium color="black" @click="onExport">
                            <v-icon medium class="bulding-id-icon">mdi-download</v-icon> Export
                        </v-btn>
                    </div>
                </div>
                <div v-else-if="this.tabs[selectedTab].value === 'selectionSearch'">
                    <div class="assignment-filters">
                        <v-select
                            v-model="filter.status"
                            :items="status"
                            item-value="value"
                            item-text="name"
                            clearable
                            label="Status"
                            outlined
                            multiple
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <v-chip
                                    class="font-weight-bold white--text"
                                    :color="data.item.color"
                                >
                                    <v-icon>{{ data.item.icon }}</v-icon>
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                        </v-select>
                        <v-menu
                            v-if="isAdminOrCompanyCoordinator"
                            v-model="createdAtMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            class="filter-field"
                            :disabled="disabled"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="filterCreatedAtDateText"
                                    class="filter-field calendar"
                                    label="Δημιουργήθηκε"
                                    readonly
                                    clearable
                                    @click:clear="filterCreatedAtDateRange = []"
                                    v-bind="attrs"
                                    v-on="on"
                                    :disabled="disabled"
                                >
                                    <template v-slot:prepend-inner>
                                        <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker
                                v-model="filterCreatedAtDateRange"
                                range
                                color="#0047AB"
                                locale="el"
                                @change="filterCreatedAtDateSelected"
                                @input="() => { if (filterCreatedAtDateRange.length === 2) { createdAtMenu = false }}"
                                :disabled="disabled"
                            ></v-date-picker>
                        </v-menu>
                        <v-select
                            v-if="isAdminOrCompanyCoordinator && clients.length > 1"
                            v-model="filter.client"
                            :items="clients"
                            :color="theming.cardsAndTablesText || 'black'"
                            item-value="id"
                            item-text="name"
                            label="Πάροχος"
                            clearable
                            outlined
                            @change="onClientSelect"
                            class="selection-field"
                            :disabled="disabled"
                        ></v-select>
                        <v-select
                            v-if="isAdminOrCompanyCoordinator"
                            v-model="filter.contractor"
                            :items="contractors"
                            item-value="id"
                            item-text="name"
                            label="Εργολάβος"
                            clearable
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                            </template>
                        </v-select>
                        <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            class="filter-field"
                            :disabled="disabled"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="filterDateText"
                                    class="filter-field calendar"
                                    label="Ανατέθηκε"
                                    readonly
                                    clearable
                                    @click:clear="filterDateRange = []"
                                    v-bind="attrs"
                                    v-on="on"
                                    :disabled="disabled"
                                >
                                    <template v-slot:prepend-inner>
                                        <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker
                                v-model="filterDateRange"
                                range
                                color="#0047AB"
                                locale="el"
                                @change="filterDateSelected"
                                @input="() => { if (filterDateRange.length === 2) { menu = false }}"
                                :disabled="disabled"
                            ></v-date-picker>
                        </v-menu>
                        <v-autocomplete
                            v-model="filter.location"
                            clearable
                            chips
                            label="Περιοχές"
                            item-value="id"
                            item-text="name"
                            :items="locations"
                            class="selection-field locations"
                            multiple
                            :disabled="disabled"
                            outlined
                        ></v-autocomplete>
                        <v-select
                            v-model="backOfficeFilterSelection"
                            :items="backOfficeStages"
                            item-value="value"
                            item-text="name"
                            multiple
                            clearable
                            label="Back Office (Μη ολοκληρωμένα)"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <v-chip
                                    class="font-weight-bold"
                                >
                                    <span class="font-weight-bold">{{ data.item.name }}</span>
                                </v-chip>
                            </template>
                        </v-select>
                        <v-select
                            v-model="filter.excavationDemand"
                            :items="booleanOptions"
                            clearable
                            label="Αίτηση Εκσκαφής"
                            item-value="value"
                            item-text="text"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.text }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-model="filter.excavationPermitted"
                            :items="booleanOptions"
                            clearable
                            label="Άδεια Εκσκαφής"
                            item-value="value"
                            item-text="text"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.text }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-model="filter.prodesmeusiDifference"
                            :items="prodesmeusiDifferenceStages"
                            item-value="value"
                            item-text="name"
                            clearable
                            label="Διαφορά Προδέσμευσης"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-model="filter.type"
                            :items="types"
                            item-value="value"
                            item-text="name"
                            clearable
                            label="Τύπος"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                            @change="onTypeChange"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if="'PILOT' === this.filter.type"
                            v-model="filter.smartReadiness"
                            :items="booleanOptions"
                            item-text="text"
                            item-value="value"
                            clearable
                            label="Smart Readiness"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.text }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if="'PILOT' === this.filter.type && this.filter.smartReadiness"
                            v-model="filter.secondTimeSmartReadiness"
                            :items="booleanOptions"
                            clearable
                            label="Δεύτερη φορά Smart Readiness"
                            item-value="value"
                            item-text="text"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.text }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if="['PILOT', 'PILOT_UFBB'].includes(this.filter.type) && autopsyStatuses.length > 1"
                            v-model="filter.autopsy.status"
                            :items="autopsyStatuses"
                            item-value="value"
                            item-text="name"
                            label="Αυτοψία"
                            clearable
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if="['PILOT', 'PILOT_UFBB'].includes(this.filter.type) && this.filter.autopsy.status === 'STARTED' && autopsyStatuses.length > 1"
                            v-model="filter.autopsy.subStatus"
                            :items="autopsySubStatuses"
                            item-value="value"
                            item-text="name"
                            label="Αυτοψία Substatus"
                            clearable
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if=" ['PILOT', 'MALFUNCTION'].includes(this.filter.type) && earthworkStatuses.length > 1"
                            v-model="filter.earthwork.status"
                            :items="earthworkStatuses"
                            item-value="value"
                            item-text="name"
                            label="Χωματουργικά"
                            clearable
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if=" ['PILOT', 'MALFUNCTION'].includes(this.filter.type) && blowingStatuses.length > 1"
                            v-model="filter.blowing.status"
                            :items="blowingStatuses"
                            item-value="value"
                            item-text="name"
                            label="Εμφύσηση"
                            clearable
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if=" ['PILOT', 'MALFUNCTION'].includes(this.filter.type) && constructionStatuses.length > 1"
                            v-model="filter.construction.status"
                            :items="constructionStatuses"
                            item-value="value"
                            item-text="name"
                            label="Κατασκευή"
                            clearable
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if=" ['PILOT', 'MALFUNCTION'].includes(this.filter.type) && weldingStatuses.length > 1"
                            v-model="filter.welding.status"
                            :items="weldingStatuses"
                            item-value="value"
                            item-text="name"
                            label="Κολλήσεις / Μετρήσεις"
                            clearable
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if=" ['PILOT', 'LAST_DROP'].includes(this.filter.type) && otoStatuses.length > 1"
                            v-model="filter.oto.status"
                            :items="otoStatuses"
                            item-value="value"
                            item-text="name"
                            label="ΟΤΟ"
                            clearable
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if=" ['PILOT', 'LAST_DROP'].includes(this.filter.type) && activationStatuses.length > 1"
                            v-model="filter.activation.status"
                            :items="activationStatuses"
                            item-value="value"
                            item-text="name"
                            label="Ενεργοποίηση"
                            clearable
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                            </template>
                        </v-select>
                    </div>
                    <div class="search-button-wrapper">
                        <v-btn v-if="!(this.filter.address || this.filter.clientName || this.filter.sr || this.filter.buildingId)" class="mx-2 white--text" medium color="black" @click="onSearch">
                            <v-icon medium class="bulding-id-icon">mdi-filter</v-icon> Αναζητηση
                        </v-btn>
                        <v-btn v-if="containsAny(['ROLE_ADMIN', 'ROLE_COORDINATOR'], userRoles)" class="mx-2 white--text" medium color="black" @click="onExport">
                            <v-icon medium class="bulding-id-icon">mdi-download</v-icon> Export
                        </v-btn>
                    </div>
                </div>
                <div v-else>
                    <div class="assignment-filters">
                        <div>
                            <v-select
                                v-if="isAdminOrCompanyCoordinator"
                                v-model="filter.taskAppointments.contractor"
                                :items="contractors"
                                item-value="id"
                                item-text="name"
                                label="Εργολάβος"
                                clearable
                                outlined
                                class="selection-field"
                                @click:clear="() => delete this.filter.taskAppointments.contractor"
                                :disabled="disabled"
                            >
                                <template v-slot:selection="data">
                                    <span class="font-weight-bold">{{ data.item.name }}</span>
                                </template>
                            </v-select>
                            <v-select
                                v-model="filter.taskAppointments.type"
                                :items="types"
                                item-value="value"
                                item-text="name"
                                clearable
                                label="Τύπος"
                                outlined
                                class="selection-field"
                                :disabled="disabled"
                                @click:clear="() => delete this.filter.taskAppointments.type"
                                @change="onTypeChange"
                            >
                                <template v-slot:selection="data">
                                    <span class="font-weight-bold">{{ data.item.name }}</span>
                                </template>
                            </v-select>
                        </div>
                        <div>
                            <v-select
                                v-model="selectedAppointmentTypes"
                                :items="taskTypes"
                                item-value="value"
                                item-text="name"
                                label="Τύπος Ραντεβού"
                                clearable
                                outlined
                                multiple
                                class="selection-field"
                                @click:clear="() => delete this.filter.taskAppointments.types"
                                :disabled="disabled"
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                        class="font-weight-bold"
                                    >
                                        <span class="font-weight-bold">{{ data.item.name }}</span>
                                    </v-chip>
                                </template>
                            </v-select>
                            <v-menu
                                v-model="taskAppointmentMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                class="filter-field"
                                :disabled="disabled"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="taskAppointmentFilterDateText"
                                        class="filter-field calendar"
                                        label="Ραντεβού στις"
                                        readonly
                                        clearable
                                        @click:clear="taskAppointmentFilterDateRange = []"
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="disabled"
                                    >
                                        <template v-slot:prepend-inner>
                                            <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="taskAppointmentFilterDateRange"
                                    range
                                    color="#0047AB"
                                    locale="el"
                                    @change="taskAppointmentFilterDateSelected"
                                    @input="() => { if ( taskAppointmentFilterDateRange.length === 2) { taskAppointmentMenu = false }}"
                                    :disabled="disabled"
                                ></v-date-picker>
                            </v-menu>
                        </div>
                    </div>
                    <div class="search-button-wrapper">
                        <v-btn v-if="!(this.filter.address || this.filter.clientName || this.filter.sr || this.filter.buildingId)" class="mx-2 white--text" medium color="black" @click="onSearch">
                            <v-icon medium class="bulding-id-icon">mdi-filter</v-icon> Αναζητηση
                        </v-btn>
                        <v-btn v-if="containsAny(['ROLE_ADMIN', 'ROLE_COORDINATOR'], userRoles)" class="mx-2 white--text" medium color="black" @click="onExport">
                            <v-icon medium class="bulding-id-icon">mdi-download</v-icon> Export
                        </v-btn>
                    </div>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>
<script>
    import jwtUtil from '@/utils/jwtUtil'
    import client from '@/services/client'
    import location from '@/services/location'
    import momentTimezone from 'moment-timezone'
    const COMPANY_NAME = process.env.VUE_APP_ENV_COMPANY_NAME

    export default {
        watch: {
            'filter.autopsy.status'(newVal, oldVal) {
                if (newVal && this.filter.autopsy?.status !== 'STARTED') {
                    delete this.filter.autopsy.subStatus
                }
            },
            'filter.smartReadiness'(newVal, oldVal) {
                if (!newVal) {
                    delete this.filter.secondTimeSmartReadiness
                }
            },
            'filter.type'(newVal, oldVal) {
                this.clearStepFilters()
                this.filter.smartReadiness = null
                this.filter.secondTimeSmartReadiness = null
            },
            'filter.taskAppointments'(newVal, oldVal) {
                if (newVal && Object.keys(newVal).length) {
                    Object.keys(this.filter).forEach(key => {
                        if (key !== 'taskAppointments') {
                            delete this.filter[key]
                        }
                    })
                    Object.keys(this.filter.taskAppointments).forEach(key => {
                        if (!this.filter.taskAppointments[key]) {
                            delete this.filter.taskAppointments[key]
                        }
                    })
                }
            },
            'taskAppointmentFilterDateRange'(newVal, oldVal) {
                if (newVal.length === 0) {
                    delete this.filter.taskAppointments?.finalDatetimeLte
                    delete this.filter.taskAppointments?.finalDatetimeGte
                }
            },
            'filterDateRange'(newVal, oldVal) {
                if (newVal.length === 0) {
                    delete this.filter.assignedToContractorAtLte
                    delete this.filter.assignedToContractorAtGte
                }
            },
            'filterCreatedAtDateRange'(newVal, oldVal) {
                if (newVal.length === 0) {
                    delete this.filter.createdAtLte
                    delete this.filter.createdAtGte
                }
            }
        },
        computed: {
            config() {
                return this.$store.getters.getConfig || {}
            },
            isAdminOrCompanyCoordinator() {
                return this.containsAny(['ROLE_ADMIN'], this.userRoles) || (this.containsAny(['ROLE_COORDINATOR'], this.userRoles) && this.userContractor.toLowerCase() === COMPANY_NAME.toLowerCase())
            },
            theming() {
                return this.$store.getters.getTheming || {}
            },
            userContractor() {
                return this.$store.getters.getUserContractor || ''
            },
            userRoles() {
                return jwtUtil.getRoles(this.$store.getters.getToken)
            },
            assignmentViewPreference() {
                return this.$store.getters.getAssignmentViewPreference
            },
            types() {
                return this.config.assignmentTypes
            },
            status() {
                return this.config.assignmentStatuses
            },
            backOfficeStages() {
                return this.config.backOffice?.steps
            },
            taskTypes() {
                return this.config?.taskTypes || []
            },
            autopsySubStatuses() {
                return this.config?.autopsy?.subStatuses || []
            },
            autopsyStatuses() {
                const autopsyStatuses = this.config?.autopsy?.statuses || []
                autopsyStatuses.push({ name: 'Μη Συμπληρωμένη', value: -1 })
                return autopsyStatuses
            },
            earthworkStatuses() {
                const earthworkStatuses = this.config?.earthwork?.statuses || []
                earthworkStatuses.push({ name: 'Μη Συμπληρωμένη', value: -1 })
                return earthworkStatuses
            },
            blowingStatuses() {
                const blowingStatuses = this.config?.blowing?.statuses || []
                blowingStatuses.push({ name: 'Μη Συμπληρωμένη', value: -1 })
                return blowingStatuses
            },
            constructionStatuses() {
                const constructionStatuses = this.config?.construction?.statuses || []
                constructionStatuses.push({ name: 'Μη Συμπληρωμένη', value: -1 })
                return constructionStatuses
            },
            weldingStatuses() {
                const weldingStatuses = this.config?.welding?.statuses || []
                weldingStatuses.push({ name: 'Μη Συμπληρωμένη', value: -1 })
                return weldingStatuses
            },
            otoStatuses() {
                const otoStatuses = this.config?.oto?.statuses || []
                otoStatuses.push({ name: 'Μη Συμπληρωμένη', value: -1 })
                return otoStatuses
            },
            activationStatuses() {
                const activationStatuses = this.config?.activation?.statuses || []
                activationStatuses.push({ name: 'Μη Συμπληρωμένη', value: -1 })
                return activationStatuses
            },
            areLikeFiltersClear() {
                if (!this.filter.sr && !this.filter.buildingId && !this.filter.address && !this.filter.clientName) {
                    return true
                }
                return false
            },
            getSizeFromRouteQuery() {
                const routeQuery = this.$route.query
                if (routeQuery && routeQuery.size && !isNaN(routeQuery.size)) {
                    return parseInt(routeQuery.size)
                }
                return 5
            },
            getPageFromRouteQuery() {
                const routeQuery = this.$route.query
                if (routeQuery && routeQuery.page && !isNaN(routeQuery.page)) {
                    return parseInt(routeQuery.page)
                }
                return 1
            }
        },
        data() {
            return {
                backOfficeFilterSelection: [],
                sortBy: null,
                panel: undefined,
                contractors: [],
                locations: [],
                clients: [],
                filterDateRange: [],
                filterCreatedAtDateRange: [],
                taskAppointmentFilterDateRange: [],
                selectedAppointmentTypes: [],
                filterDateText: '',
                filterCreatedAtDateText: '',
                taskAppointmentFilterDateText: '',
                menu: false,
                createdAtMenu: false,
                taskAppointmentMenu: false,
                selectedTab: 0,
                booleanOptions: [
                    {
                        text: 'Ναι',
                        value: true
                    },
                    {
                        text: 'Όχι',
                        value: false
                    }
                ],
                prodesmeusiDifferenceStages: [
                    {
                        name: 'Εμφύσηση',
                        value: 'blowing'
                    },
                    {
                        name: 'Κατασκευή',
                        value: 'construction'
                    },
                    {
                        name: 'Κολλήσεις/Μετρήσεις',
                        value: 'welding'
                    }
                ],
                sortSelections: [
                    { text: 'Age', value: 'age' },
                    { text: 'Δημιουργία', value: 'createdAt' },
                    { text: 'Ανάθεση σε εργολάβο', value: 'assignedToContractorAt' },
                    { text: 'Status', value: 'status' },
                    { text: 'Όνομα Πελάτη', value: 'clientName' },
                    { text: 'Building Id', value: 'buildingId' },
                    { text: 'Location', value: 'location' },
                    { text: 'Διέυθυνση', value: 'address' },
                    { text: 'Τύπο', value: 'type' }
                ],
                tabs: [
                    {
                        text: 'ΕΛΕΥΘΕΡΗ ΑΝΑΖΗΤΗΣΗ',
                        value: 'freeSearch'
                    },
                    {
                        text: 'ΑΝΑΖΗΤΗΣΗ ΜΕ ΕΠΙΛΟΓΕΣ',
                        value: 'selectionSearch'
                    },
                    {
                        text: 'ΑΝΑΖΗΤΗΣΗ ΜΕ ΡΑΝΤΕΒΟΥ',
                        value: 'appointmentSearch'
                    }
                ],
                filter: {
                    address: null,
                    clientName: null,
                    buildingId: null,
                    sr: null,
                    location: [],
                    contractor: null,
                    backOffice: null,
                    taskAppointments: { types: [] }
                },
                disabled: false,
                sortType: 'ASC',
                likeFilterFields: ['address', 'sr', 'buildingId', 'clientName'],
                stepFilterFields: ['autopsy', 'earthwork', 'blowing', 'construction', 'welding', 'oto', 'activation'],
                restFilterFields: ['smartReadiness', 'status', 'prodesmeusiDifference', 'location', 'contractor', 'type', 'assignedToContractorAtLte', 'assignedToContractorAtGte', 'createdAtLte', 'createdAtGte', 'backOffice', 'excavationDemand', 'excavationPermitted']
            }
        },
        created() {
            this.getAllClients()
            this.getAllLocations()
            this.initFilters()
        },
        methods: {
            selectTab() {
                this.clearFilters()
            },
            shouldTabBeDisabled(tab) {
                const isAppointmentSearch = (this.filter.taskAppointments && Object.keys(this.filter.taskAppointments).length > 0) || this.selectedAppointmentTypes.length > 0 || this.taskAppointmentFilterDateRange.length > 0
                if (((tab.value === 'selectionSearch' || tab.value === 'appointmentSearch') && !this.areLikeFiltersClear) ||
                    ((tab.value === 'selectionSearch' || tab.value === 'freeSearch') && isAppointmentSearch)) {
                    return true
                } else {
                    return false
                }
            },
            toggleClearButton() {
                this.clearFilters()
                this.onSearch()
            },
            clearStepFilters() {
                this.filter.autopsy = { status: null, subStatus: null }
                this.filter.earthwork = { status: null }
                this.filter.welding = { status: null }
                this.filter.blowing = { status: null }
                this.filter.construction = { status: null }
                this.filter.oto = { status: null }
                this.filter.activation = { status: null }
                this.filter.backOffice = null
            },
            clearFilters() {
                this.filterDateText = ''
                this.filterCreatedAtDateText = ''
                this.taskAppointmentFilterDateText = ''
                this.filter.sr = null
                this.filter.address = null
                this.filter.clientName = null
                this.filter.buildingId = null
                this.filter.excavationDemand = null
                this.filter.excavationPermitted = null
                this.filter.smartReadiness = null
                this.filter.secondTimeSmartReadiness = null
                this.filter.status = null
                this.filter.prodesmeusiDifference = null
                this.filter.location = []
                this.filter.contractor = null
                this.filter.type = null
                this.filter.assignedToContractorAtLte = null
                this.filter.assignedToContractorAtGte = null
                this.backOfficeFilterSelection = []
                this.selectedAppointmentTypes = []
                this.taskAppointmentFilterDateRange = []
                this.filter.taskAppointments = {}
                this.clearStepFilters()
            },
            deepMerge(target, source) {
                for (const key in source) {
                    if (
                        source[key] instanceof Object &&
                        key in target &&
                        target[key] instanceof Object
                    ) {
                        this.deepMerge(target[key], source[key])
                    } else {
                        target[key] = source[key]
                    }
                }
                return target
            },
            initFilters() {
                const storedFilter = JSON.parse(localStorage.getItem('assignment-filters')) || {}
                this.clearFilters()
                const storedSort = JSON.parse(localStorage.getItem('sort')) || ['age', 'DESC']
                if (storedSort.length > 0) {
                    this.sortBy = storedSort[0]
                    this.sortType = storedSort[1]
                }

                this.filter = this.deepMerge(this.filter, storedFilter)

                this.selectedTab = 0
                let shouldToggle = false
                if (this.filter.backOffice?.length > 0) {
                    this.backOfficeFilterSelection = this.filter.backOffice.map(filter => Object.keys(filter)[0])
                    shouldToggle = true
                    this.selectedTab = 1
                }
                this.likeFilterFields.forEach(field => {
                    if (storedFilter[field]) {
                        this.filter[field] = storedFilter[field].replaceAll('%', '')
                        shouldToggle = true
                    }
                })
                this.restFilterFields.forEach(field => {
                    if (storedFilter[field]) {
                        shouldToggle = true
                        this.selectedTab = 1
                    }
                })
                if (this.filter.taskAppointments?.types) {
                    this.selectedAppointmentTypes = this.filter.taskAppointments.types
                    shouldToggle = true
                    this.selectedTab = 2
                }
                if (this.filter.taskAppointments?.contractor) {
                    shouldToggle = true
                    this.selectedTab = 2
                }
                if (this.filter.assignedToContractorAtLte && this.filter.assignedToContractorAtGte) {
                    const gte = momentTimezone(this.filter.assignedToContractorAtGte).tz('Europe/Athens').utc().format('YYYY-MM-DD')
                    const lte = momentTimezone(this.filter.assignedToContractorAtLte).tz('Europe/Athens').utc().format('YYYY-MM-DD')
                    this.filterDateRange = [gte, lte]
                    this.filterDateText = gte.toString() + ' ~ ' + lte.toString()
                }
                if (this.filter.createdAtLte && this.filter.createdAtGte) {
                    const gte = momentTimezone(this.filter.createdAtGte).tz('Europe/Athens').utc().format('YYYY-MM-DD')
                    const lte = momentTimezone(this.filter.createdAtLte).tz('Europe/Athens').utc().format('YYYY-MM-DD')
                    this.filterCreatedAtDateRange = [gte, lte]
                    this.filterCreatedAtDateText = gte.toString() + ' ~ ' + lte.toString()
                }
                if (this.filter.taskAppointments?.finalDatetimeLte && this.filter.taskAppointments?.finalDatetimeGte) {
                    const gte = momentTimezone(this.filter.taskAppointments.finalDatetimeGte).tz('Europe/Athens').utc().format('YYYY-MM-DD')
                    const lte = momentTimezone(this.filter.taskAppointments.finalDatetimeLte).tz('Europe/Athens').utc().format('YYYY-MM-DD')
                    this.taskAppointmentFilterDateRange = [gte, lte]
                    this.taskAppointmentFilterDateText = gte.toString() + ' ~ ' + lte.toString()
                    shouldToggle = true
                    this.selectedTab = 2
                }
                if (shouldToggle) {
                    this.togglePanel()
                }
            },
            toggleSortType() {
                if (this.sortType === 'ASC') {
                    this.sortType = 'DESC'
                } else {
                    this.sortType = 'ASC'
                }
                this.onSearch()
            },
            likeFieldTriggered() {
                Object.keys(this.filter).forEach(key => {
                    if (!this.likeFilterFields.includes(key)) {
                        delete this.filter[key]
                    }
                })
                this.selectedAppointmentTypes = []
                this.taskAppointmentFilterDateRange = []
                this.onSearch()
            },
            togglePanel() {
                const curr = this.panel
                this.panel = curr === undefined ? 0 : undefined
            },
            disableFilters() {
                this.filter = {}
                this.disabled = true
                this.filterDateRange = []
                this.filterCreatedAtDateRange = []
                this.filterDateText = ''
                this.taskAppointmentFilterDateText = ''
            },
            createAssignment() {
                this.$router.push(`/assignments/create`)
            },
            getProccessedFilter() {
                let filter = { ...this.filter }

                // if (filter.contractor === -1) {
                //     filter.contractor = null
                // }
                if (filter.sr) {
                    filter.sr = filter.sr + '%'
                }
                if (filter.address) {
                    filter.address = '%' + filter.address + '%'
                }
                if (filter.buildingId) {
                    filter.buildingId = filter.buildingId + '%'
                }
                if (filter.clientName) {
                    filter.clientName = '%' + filter.clientName + '%'
                }
                if (filter.location?.length === 0) {
                    delete filter.location
                }
                if (filter.status?.length === 0) {
                    delete filter.status
                }
                if (this.backOfficeFilterSelection.length > 0) {
                    filter.backOffice = []
                    for (let value of this.backOfficeFilterSelection) {
                        const obj = {}
                        obj[value] = false
                        filter.backOffice.push(obj)
                    }
                }
                if (this.selectedAppointmentTypes.length > 0 || this.taskAppointmentFilterDateRange.length > 0 || this.filter.taskAppointments?.contractor) {
                    filter.taskAppointments = filter.taskAppointments || {}
                    Object.keys(filter).forEach(key => {
                        if (key !== 'taskAppointments') {
                            delete filter[key]
                        }
                    })
                }

                if (this.selectedAppointmentTypes.length > 0) {
                    filter.taskAppointments.types = this.selectedAppointmentTypes
                } else {
                    delete filter.taskAppointments?.types
                }
                if (this.taskAppointmentFilterDateRange.length === 0) {
                    delete filter.taskAppointments?.finalDatetimeGte
                    delete filter.taskAppointments?.finalDatetimeLte
                }
                if (this.sortBy) {
                    this.sort = [this.sortBy, this.sortType]
                } else {
                    this.sort = null
                }

                Object.keys(filter).forEach(key => {
                    if (typeof filter[key] === 'number' || typeof filter[key] === 'boolean') {
                        return
                    }
                    if (filter[key] && typeof filter[key] === 'object') {
                        Object.keys(filter[key]).forEach(subkey => {
                            if (!filter[key][subkey]) {
                                delete filter[key][subkey]
                            }
                        })
                    }
                    if (!filter[key] || (filter[key] && Object.keys(filter[key]).length === 0) || (filter[key] !== null && filter[key]?.status === null)) {
                        delete filter[key]
                    }
                })
                return filter
            },
            onSearch() {
                if (this.getPageFromRouteQuery !== 1) {
                    this.$router.push({ query: { page: 1, size: this.getSizeFromRouteQuery } })
                }
                this.$emit('search', this.getProccessedFilter(), this.sort)
            },
            onExport() {
                const filter = this.getProccessedFilter()
                this.$emit('export', filter, this.sort)
            },
            getAllClients() {
                this.contractors = []
                client.getAllClients().then(resp => {
                    this.clients = resp.data
                    if (this.clients.length === 1) {
                        this.filter.client = this.clients[0].id//
                        this.onClientSelect(this.clients[0].id)//
                    } else {
                        this.contractors = this.clients.flatMap(client => client.contractors)
                    }
                })
            },
            changeView() {
                if (this.assignmentViewPreference === 'array') {
                    this.$store.dispatch('setAssignmentViewPreference', 'cards')
                } else {
                    this.$store.dispatch('setAssignmentViewPreference', 'array')
                }
            },
            onTypeChange(e) {
                this.clearStepFilters()
                this.filter = { ...this.filter }
            },
            getAllLocations() {
                location.getAll().then(resp => {
                    this.locations = resp.data
                    this.locations.push({ id: null, name: 'Χωρίς Περιοχή' })
                })
            },
            filterDateSelected(dateRange) {
                this.filterDateText = dateRange[0] + ' ~ ' + dateRange[1]
                this.filter.assignedToContractorAtGte = momentTimezone(dateRange[0] + ' 00:00:00').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
                this.filter.assignedToContractorAtLte = momentTimezone(dateRange[1] + ' 23:59:59').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
            },
            filterCreatedAtDateSelected(dateRange) {
                this.filterCreatedAtDateText = dateRange[0] + ' ~ ' + dateRange[1]
                this.filter.createdAtGte = momentTimezone(dateRange[0] + ' 00:00:00').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
                this.filter.createdAtLte = momentTimezone(dateRange[1] + ' 23:59:59').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
            },
            taskAppointmentFilterDateSelected(dateRange) {
                this.taskAppointmentFilterDateText = dateRange[0] + ' ~ ' + dateRange[1]
                this.filter.taskAppointments = this.filter.taskAppointments || {}
                this.filter.taskAppointments.finalDatetimeGte = momentTimezone(dateRange[0] + ' 00:00:00').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
                this.filter.taskAppointments.finalDatetimeLte = momentTimezone(dateRange[1] + ' 23:59:59').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
            },
            containsAny(arr1, arr2) {
                return arr1.some(item => arr2.includes(item))
            },
            onClientSelect(clientId) {
                const selectedClient = this.clients.find(client => client.id === clientId)
                if (selectedClient) {
                    this.contractors = selectedClient.contractors
                    this.contractors.push({ id: -1, name: 'Κανένας' })
                }
            }
        }
    }
</script>
<style>
.v-expansion-panel-header__icon {
    display: none !important;
}
/* .v-text-field__details {
    display: none;
} */
</style>
<style scoped>
.filter-buttons, .sort-wrapper, .create-new {
    flex: 1 1 33.33%;
}
.filter-buttons {
    font-size: 1.4rem;
    align-items: center;
    min-width: 270px;
}
.create-new {
    display: flex;
    justify-content: flex-end;
}
.sort-by-selection {
    margin-left: 0.5rem
}
.expansion-panel {
    max-width: 90%;
    margin: 0 auto;
}
.assignment-filters {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
}
.v-expansion-panel {
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}
.filters-panel {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
}

.sort-wrapper {
    display: flex;
    align-items: center;
    min-width: 200px;
    padding: 0.5rem;
}

.more-filters-button-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
    align-items: center;
}

.selection-field {
    max-width: 400px;
    width: 400px;
    padding: 0.8rem;
}

.selection-field.locations {
    width: 96%;
    max-width: 96%;
}

.filter-field {
    padding: 0.8rem;
    padding-top: 1.5rem;
}

.filter-field.calendar {
    max-width: 400px;
}

.filter-field.client-name {
    min-width: 270px;
}

.filter-field.sr {
    min-width: 270px;
}
.filter-field.address {
    min-width: 270px;
}
.filter-field.building-id {
    min-width: 270px;
}

.search-button-wrapper {
    display: flex;
    justify-content: center;
}

.bulding-id-icon {
    color: #0000A3;
}

.card-title-2 {
    font-weight: 500;
    font-size: 1.25rem;
}

.like-search-wrapper {
    display: flex;
    flex-wrap: wrap;
}

@media only screen and (max-width: 1085px) {
    .create-new {
        justify-content: center;
    }
}
</style>
